module.exports = __webpack_public_path__ + "img/logo.348d388d.png";